import { Disclaimer } from '@3ddv/ngx-sites-builder-lib';
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidebarService } from '../../../sb-editor-sidebar/services/sidebar.service';
import { DisclaimerService } from '../services/disclaimer.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Sidebar } from '../../../sb-editor-sidebar/models/sidebar.model';
import { DisclaimerPreviewComponent } from './disclaimer-preview/disclaimer-preview.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-disclaimer-generator',
  templateUrl: './disclaimer-generator.component.html',
  styleUrls: ['./disclaimer-generator.component.scss'],
})
export class DisclaimerGeneratorComponent {
  @Input() tool: Disclaimer;
  public itemList: Array<any>;
  private subscriptions: Array<Subscription> = [];
  public newDisclaimer: any = {
    name: '',
    type: 'vip',
    color: '',
  };

  public generationMode: { mode: 'create' | 'edit' | null } = { mode: null };
  public itemToEdit: any = null;
  public confirmDelete: boolean = false;
  @ViewChild('previewitem', { static: false }) previewitemComponent: DisclaimerPreviewComponent;

  public sidebar: Sidebar;

  public previewDisclaimer = {
    show: true,
  };
  public bsModalRef: BsModalRef;

  public postedFile;
  public downloadTemplate: SafeUrl;
  public filename: string;

  constructor(
    private disclaimerService: DisclaimerService,
    private sidebarService: SidebarService,
    public changeDetector: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.tool.colorText = this.tool.colorText || '#ffffff';
    this.tool.colorBg = this.tool.colorBg || '#000000';
    if (this.tool.data) {
      this.filename = 'Fichero JSON subido';
    }
    this.itemList = JSON.parse(JSON.stringify(this.tool.data));
    const sidebar$ = this.sidebarService.getAsyncSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);

    this.generateTemplate();

    var tempFile = this.disclaimerService.getTempFile();
    if (tempFile) {
      this.postedFile = tempFile;
    }

    if (this.tool.fileData) {
      this.tool.data = JSON.parse(JSON.stringify(this.tool.fileData));
      this.tool = this.disclaimerService.addCustomData(this.tool);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  private generateTemplate() {
    let template = {
      S_537: {
        text: 'Esto es una línea.\nEsto es otra línea.\nY otra más.',
        seatmap: true,
        pano: false,
      },
    };

    let data = JSON.stringify(template);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }

  private readFile(file) {
    this.postedFile = file;
    this.disclaimerService.saveTempFile(file);
    const fileReader = new FileReader();
    fileReader.readAsText(this.postedFile, 'UTF-8');
    fileReader.onload = () => {
      this.tool.fileData = JSON.parse(fileReader.result.toString());
      this.tool.data = JSON.parse(JSON.stringify(this.tool.fileData));
      this.tool = this.disclaimerService.addCustomData(this.tool);
    };
  }

  public onFileSelected($event) {
    if (!$event.target.files.length) return;
    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      $event.target.files[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    this.readFile($event.target.files[0]);
  }

  public onFileDropped($event) {
    if (!$event.length) return;
    if (($event[0].type == '' && $event[0].size == 0) || $event[0].type != 'application/json') {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    this.readFile($event[0]);
  }

  public deleteDroppedFile() {
    this.postedFile = null;
    this.tool.file = null;
    this.tool.fileData = null;
    // Reset de la tool.data para borrar los datos que vinieran del file y volver a guardarle los que vengan de custom text para no perderlos.
    this.tool.data = null;
    // Adds or overwrites customData to tool.data
    this.tool = this.disclaimerService.addCustomData(this.tool);
  }

  public editItem($event) {}

  public moveItem($move) {}

  public toggleGenerationMode(mode: 'create' | 'edit') {}

  public savedItem($event) {}

  public cancelItem($event: null) {}
}
